<div><h4 class="border-bottom">{{'Contact.Subscription' | translate}}</h4></div>
<div class="ontario-row field">
  @if (showNA) {
    <div class="ontario-column answer-text">{{'General.NA' | translate}}</div>
  }
  @if (!showNA && optInForText) {
    <div class="ontario-column answer-text">{{'General.Yes' | translate}}</div>
  }
  @if (!showNA && !optInForText) {
    <div class="ontario-column answer-text">{{'General.No' | translate}}</div>
  }
  <div class="ontario-end ">{{'Contact.OptinForEmail' | translate}}</div>
</div>
<div class="ontario-row field">
  @if (showNA) {
    <div class="ontario-column answer-text">{{'General.NA' | translate}}</div>
  }
  @if (!showNA && optInForEmail) {
    <div class="ontario-column answer-text">{{'General.Yes' | translate}}</div>
  }
  @if (!showNA && !optInForEmail) {
    <div class="ontario-column answer-text">{{'General.No' | translate}}</div>
  }
  <div class="ontario-end">{{'Contact.OptinForSMS' | translate}}</div>
</div>
